import React, { useContext, useEffect, useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import Container from 'components/Container'
import Row from 'components/Row'
import Col from 'components/Col'
import { PageTitle, PageSubtitle, TooltipHintWrapper } from 'flow/SiteProposal/pages/About/style'
import Threats from './component/Threats'
import { SiteContext } from 'providers/site'
import ScrollToTop from 'components/ScrollToTop'
import { createMonitoringPressure } from 'api/monitoring'
import { MonitoringContext } from 'providers/monitoring'
import { ErrorWrapper, PageSubtitleWrapper } from './style'
import ErrorIcon from 'assets/icons/error-input-trailing-icon'
import Tooltip from 'components/Tooltip'
import InfoIcon from 'assets/icons/info-icon'

const MonitoringPressure = () => {
  const params = useParams()
  const location = useLocation()
  const { site } = useContext(SiteContext)
  const [pressureId, setPressureId] = useState()
  const [showTriggerEvaluation, setShowTriggerEvaluation] = useState(false)
  const [initialPreselected, setInitialPreselected] = useState(null)
  const [initialOpenModalForThreatId, setInitialOpenModalForThreatId] = useState(null)
  const [initialOpenTab, setInitialOpenTab] = useState(null)
  const { monitoringProposalFieldValidation, getUncompletedSection, isEditable } = useContext(MonitoringContext)
  const [refreshCounter, setRefreshCounter] = useState(0)
  const sitePressureValidation = monitoringProposalFieldValidation?.sitePressure

  const getPressureAPICall = () => {
    const monitoringId = params?.monitoringId
    createMonitoringPressure(monitoringId)
      .then((response) => {
        setPressureId(response.id)
        params.pressureId = response.id;
      })
      .catch((err) => {
        console.error('[Pressure] createMonitoringPressure failed', err)
      })
  }

  useEffect(() => {
    getPressureAPICall()
    if (location && location.state) {
      if (location.state.preselected) {
        setInitialPreselected(location.state.preselected)
        setShowTriggerEvaluation(Boolean(location.state.openAddDetails) || Boolean(location.state.preselected))
      }
      if (location.state.modalOpen && location.state.modalThreatId) {
        setInitialOpenModalForThreatId(location.state.modalThreatId)
      }
      if (location.state.openTab) {
        setInitialOpenTab(location.state.openTab)
      } else {
        setInitialOpenTab(null)
      }
    } else {
      setInitialOpenTab(null)
    }
  }, [params?.monitoringId, location])

  const handleBackToPressure = () => {
    setShowTriggerEvaluation(false)
     setRefreshCounter((prev) => prev + 1)
  }

  return (
    <div>
      {!showTriggerEvaluation && (
        <>
          <PageTitle data-test="legend">
            <FormattedMessage id="pressureTitle" />
          </PageTitle>

          <PageSubtitleWrapper>
            <PageSubtitle>
              <FormattedMessage id="chooseThreats" />
            </PageSubtitle>
            <Tooltip
              style={{ zIndex: 1000 }}
              placement="bottom"
              trigger={['hover']}
              align={{ offset: [0, 16] }}
              overlay={{
                label: 'pressureTitle',
                infoTooltip: 'pressureEvaluationHint'
              }}
              type="big"
            >
              <TooltipHintWrapper>
                <InfoIcon />
              </TooltipHintWrapper>
            </Tooltip>
          </PageSubtitleWrapper>
          {!sitePressureValidation?.result && sitePressureValidation?.threatIds.length === 0 && (
            <ErrorWrapper>
              <ErrorIcon />
              <FormattedMessage id="pressureTriggerValidation" />
            </ErrorWrapper>
          )}
        </>
      )}
      {showTriggerEvaluation && <div style={{ height: '100px' }} />}
      <Container width="100%">
        <Row>
          <Col md={12}>
            {pressureId && (
              <Threats
                site={site}
                pressure={pressureId}
                disabled={false}
                showTriggerEvaluation={showTriggerEvaluation}
                setShowTriggerEvaluation={setShowTriggerEvaluation}
                initialSelectedPressure={initialPreselected}
                initialModalInfo={{ modalThreatId: initialOpenModalForThreatId }}
                initialOpenTab={initialOpenTab}
                checkPressureThreatsCompleted={getUncompletedSection}
                isEditable={isEditable}
                onBackToPressure={handleBackToPressure}
                refreshThreats={refreshCounter}
              />
            )}
          </Col>
        </Row>
        <ScrollToTop bottom="104px" />
      </Container>
    </div>
  )
}

export default MonitoringPressure
